<template>
<div ref="pay-card-otp" id="pay-card-otp" class="opt-content-wrapper pay-pane active py-3 px-2">

    <div v-if="loading" class="py-5">
        <Spinner class="my-2 animate slideInTop" :color="client_info.colors.loading_spinner" >
        Please wait, processing transaction
        </Spinner>
    </div>

    <div v-else class="modal-body pb-1">
        <div class="row m-0">
            <p  v-html="this.data.details.message" class="mx-auto" ></p>
            <div class="col-12 px-0">
                <div class="form-group ">
                    <form class="pay-otp-code" @submit.prevent="validate">
                        <input :type="showNum ? isOTP ? 'number' : 'password' : 'text'" class="form-control no-label text-center" @keyup.enter="validate" v-model="trx_otp" id="otpInput" ref="otpInput" maxlength="14" autocomplete="off" minlength="4" autofocus required @focus="isFocus = true" @blur="isFocus = false" :style="{ borderColor: (isFocus ? appColor : '#e4e4e4')  }" />
                        <span class="invalid-feedback" :style="(errors.trx_otp) ? 'display : inline' : ''">{{ otp_error_message }}</span>
                    </form>
                </div>
            </div>

            <div class="col-12 px-0">
                <div v-if="!loading" class="form-group text-center mb-0">
                    <a href="javascript:void(0)" class="text-tiny" @click.prevent="tryAgain">Go Back</a>
                </div>
                <div class="form-group mb-0 mt-3">
                    <button type="submit" class="btn app-bg-color" :style="button_color" ref="btnActionSendOtp" id="btnActionSendOtp" @click.prevent="validate" @keyup.enter="validate">Make Payment</button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import Spinner from './includes/Spinner.vue';

export default {
    name: 'otp',
    props: ['data', 'appColor', 'client_info', 'button_color'],
    components: {
        Spinner
    },
    created() {
        if (this.data.details.message && this.data.details.message.includes('name'))
            this.showNum = false
        else
            this.showNum = true;

    },
    watch: {
        trx_otp(newVal) {
            if (this.errors.trx_otp) {
                this.errors.trx_otp = false;
                this.trx_otp = newVal;
            }
        },
        isFocus(newVal) {
            if (newVal)
                this.focusColor = this.appColor

        }
    },
    data() {
        return {
            trx_otp: '',
            otp_error_message: '',
            isFocus: true,
            isOTP: true,
            focusColor: '',
            showNum: true,
            loading: false,
            errors: {
                trx_otp: false,
            }
        }
    },
    methods: {
        tryAgain() {
            const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef()}`;
            this.$store.dispatch('transRef', newRef);
            this.$store.dispatch('isFailed', true);
            this.$parent.changeComponent('CardPayment');
            this.loading = false;
        },

        validate() {
            if (this.trx_otp.length <= 0) {
                this.errors.trx_otp = true;
                this.otp_error_message = "Please supply OTP code.";
                this.$refs.otpInput.focus();
                return;
            }

            this.submitOtp();
        },

        resendOtp(){

        },
        submitOtp() {

            let payload = {
                    request_ref: this.$generateRequestRef(),
                    request_type: this.$store.state.payload.request_type,
                    auth: {
                        secure: this.trx_otp,
                        // auth_provider: "Quickteller"
                    },
                    transaction: {
                        transaction_ref: this.$store.state.transRef
                    }
                },
                data2 = {
                    endpoint: 'validate',
                    api_key: this.$store.state.api_key,
                    payload,
                },
                dataPayload = this.$generateToken(data2);

            this.loading = true;

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data: dataPayload,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    Authorization: `Bearer ${this.$store.state.payload.api_key}`
                }).then( ({data}) => {
                    
                    let hash = data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;
                    window.raw = JSON.stringify(res);
                    
                    this.trx_otp='';
                    
                    if(status == 'pendingvalidation'){
                        this.isOTP = false;
                    }

                    this.loading = false;
                    if (status == "successful") {
                        return  this.$parent.changeComponent('Status', {
                            reference: payload.transRef,
                            data: responseData,
                            type: 'Successful',
                            message: message || res.data.message
                        });

                    } else if (['pendingvalidation','waitingforotp'].includes(status)) {
                        return  this.$parent.changeComponent('OTP', {
                            message: message
                        });
                    }

                    window.failedFromStart = false;
                    window.failedFromStartMessage = res.message;
                    this.$router.push('/v2/warning');

                })
                .catch(error => {
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                })
        }
    }
};
</script>
